<template>
  <div class="container">
    <text-input
      :hint="placeholder"
      :scroll-on-focus="scrollOnFocus"
      :label="label"
      :value="value"
      @input="onInput"
      @click="$emit('click')"
      @onFocus="$emit('onFocus')"
      :required="required"
      pattern="[0-9]*"
      inputmode="numeric"
      :maxlength="maxlength"
      :minlength="minlength"
      :subhint="subhint"
      :validation-error="error"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import TextInput from "@/components/core/TextInput";
export default {
  name: "NumberInput",
  components: { TextInput },
  props: [
    "placeholder",
    "label",
    "value",
    "maxlength",
    "minlength",
    "subhint",
    "scrollOnFocus",
    "validationError",
    "disabled",
    "required",
  ],
  data() {
    return {
      checked: false,
    };
  },
  computed: {
    error() {
      if (this.checked && (this.required || !this.isVoid())) {
        if (this.validationError) {
          return this.validationError;
        } else if (this.isVoid()) {
          return "Tenés que ingresar este dato";
        } else if (!this.isValid()) {
          return "El número no es válido";
        }
      }
      return null;
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    },
    checkValid() {
      this.checked = true;
      return this.isValid();
    },
    isVoid() {
      return this.value == null || this.value.trim() === "";
    },
    isValid() {
      if (this.isVoid()) {
        return !this.required;
      }

      if (this.minlength) {
        if (this.value.length < this.minlength) return false;
      }

      const numberRegex = /^[0-9]*$/;
      return numberRegex.test(this.value.trim());
    },
  },
};
</script>

<style scoped></style>
